import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { graphql, Link } from "gatsby";
import Img from "gatsby-image";
import CustomSoundPlayer from "../components/CustomSoundPlayer";
import { ArrowLeft } from "react-feather";

import Layout from "../components/Layout";
import Content, { HTMLContent } from "../components/Content";
import { FiDownload } from "react-icons/fi";
import { isYoutubeLink } from "../utils";
import SubscribeModal from "../components/SubscribeModal.jsx";

export const BlogPostTemplate = props => {
  const PostContent = props.contentComponent || props.Content;
  let clientId = "L6pWQKWWm6oT4Nv0mTWEkxKypNpleA5m";

  return (
    <section className="section">
      {props.helmet || ""}
      <div className="container blog-post">
        <Link to="/" className="back-link">
          <ArrowLeft size={20} className="mr-1" />
          <span>Back</span>
        </Link>
        <div className="row">
          <div className="col-4 image-col">
            <Img
              fluid={
                props.Image
                  ? props.image.childImageSharp.fluid
                  : props.defaultImage.childImageSharp.fluid
              }
            />
          </div>
          <div className="col-8">
            <h1 className="blog-post-header">{props.title}</h1>
            <iframe
              width="100%"
              height="20"
              scrolling="no"
              frameborder="no"
              allow="autoplay"
              src={`https://w.soundcloud.com/player/?url=${props.soundcloudLink}&color=%23ff5500&inverse=false&auto_play=false&show_user=true`}
            ></iframe>
            <PostContent content={props.content} />
            {isYoutubeLink(props.youtubeLink) && (
              <iframe
                type="text/html"
                width="640"
                height="360"
                src={props.youtubeLink
                  .replace("watch", "embed")
                  .replace("?v=", "/")}
                frameborder="0"
                style={{ marginBottom: "1rem" }}
              ></iframe>
            )}
            {props.dropboxLink ? (
              <a
                href={props.dropboxLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="d-flex align-items-center">
                  <FiDownload size={"20px"} className="mr-1" />
                  <span>Download via Dropbox</span>
                </div>
              </a>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

BlogPostTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  title: PropTypes.string,
  helmet: PropTypes.object,
  soundcloud: PropTypes.string,
  dropboxLink: PropTypes.string,
  youtubeLink: PropTypes.string,
  image: PropTypes.object,
  tags: PropTypes.array
};

const BlogPost = ({ data }) => {
  const { markdownRemark: post, defaultImage } = data;

  return (
    <Layout>
      <SubscribeModal />
      <BlogPostTemplate
        content={post.html}
        contentComponent={HTMLContent}
        description={""}
        helmet={
          <Helmet titleTemplate="%s | Blog">
            <title>{`${post.frontmatter.title}`}</title>
            <meta
              name="description"
              content={`${post.frontmatter.description}`}
            />
          </Helmet>
        }
        title={post.frontmatter.title}
        image={post.frontmatter.image}
        defaultImage={defaultImage}
        dropboxLink={post.frontmatter.dropboxLink}
        soundcloudLink={post.frontmatter.soundcloud}
        youtubeLink={post.frontmatter.youtubeLink}
      />
    </Layout>
  );
};

BlogPost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object
  })
};

export default BlogPost;

export const pageQuery = graphql`
  query BlogPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        soundcloud
        dropboxLink
        youtubeLink
        image {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        tags
      }
    }
    defaultImage: file(relativePath: { eq: "sean.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;
